import React from 'react';
import {
  CapacityMatrix,
  CircuitOutlookSection,
  SUBSTATION_ROWS,
} from '../common/CapacityOutlookTables';

/**
 * Renders the multi-year "Additional Matrices" for a location:
 *  - Nearest / max-capacity circuit Available Load Capacity (MW)
 *  - A Bank available capacity outlook (MW) under each circuit
 *  - Nearest substation available capacity outlook (MW)
 *
 * @param {object|null} nearestAlc       alc_multiyear for the nearest circuit
 * @param {object|null} maxAlc           alc_multiyear for the max-capacity circuit
 * @param {string} [nearestName]         name of the nearest circuit (for the title)
 * @param {string} [maxName]             name of the max-capacity circuit (for the title)
 * @param {object|null} [substationOutlook] multi-year outlook for the nearest substation
 * @param {string} [substationName]      name of the nearest substation (for the title)
 */
export default function AdditionalMatrices({
  nearestAlc,
  maxAlc,
  nearestName,
  maxName,
  substationOutlook,
  substationName,
}) {
  const renderTitle = (label, name) => (
    <span>
      {label}
      {name ? <span className="text-gray-400 font-normal"> · {name}</span> : null}
    </span>
  );
  const nearestTitle = renderTitle('Nearest circuit', nearestName);
  const maxTitle = renderTitle('Max nearby circuit', maxName);
  const substationTitle = renderTitle('Substation', substationName);
  const hasSceCircuit = Boolean(nearestAlc || maxAlc);
  const missingSceHint = hasSceCircuit ? 'N/A' : 'N/A (SCE only)';
  return (
    <div>
      <CircuitOutlookSection
        title={nearestTitle}
        alc={nearestAlc}
        emptyHint={nearestAlc ? 'N/A' : 'N/A (SCE only)'}
      />
      <CircuitOutlookSection
        title={maxTitle}
        alc={maxAlc}
        emptyHint={maxAlc ? 'N/A' : 'N/A (SCE only)'}
      />
      <CapacityMatrix
        title={substationTitle}
        data={substationOutlook}
        rows={SUBSTATION_ROWS}
        emptyHint={missingSceHint}
      />
    </div>
  );
}
